import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { mapPhraseWithMinusWordsToString } from '../../service/PhrasesHelpers/PhrasesHelpers';
import { GroupType } from '../../typings/domain';
import { ControlledPhraseEditPopup } from '../ControlledPhraseEditPopup/ControlledPhraseEditPopup';
import { PhraseCell } from '../PhraseCell/PhraseCell';

export interface EditablePhraseCellProps {
    id: string;
    groupId: string;
    campaignId: string;
    groupType: GroupType;
    phrase: string;
    minusWords: string[];
    groupMinusKeywords: string[];
    isEditable: boolean;
    regionIds: number[];
    columnName: string;
}

export class EditablePhraseCell extends React.Component<EditablePhraseCellProps> {
    render() {
        const {
            id,
            groupId,
            campaignId,
            groupType,
            phrase,
            minusWords,
            regionIds,
            groupMinusKeywords,
            columnName,
            isEditable
        } = this.props;

        const content = this.getContent();

        if (isEditable) {
            return (
                <ControlledPhraseEditPopup
                    phraseId={id}
                    groupId={groupId}
                    groupType={groupType}
                    campaignId={campaignId}
                    phrase={phrase}
                    minusWords={minusWords}
                    regionIds={regionIds}
                    groupMinusKeywords={groupMinusKeywords}
                    columnName={columnName}
                >
                    {content}
                </ControlledPhraseEditPopup>
            );
        }

        return content;
    }

    private getContent() {
        const { phrase, minusWords, isEditable } = this.props;

        return (
            <div
                className={Bem.cls('editable-phrase-cell')}
                title={mapPhraseWithMinusWordsToString(phrase, minusWords)}
            >
                <PhraseCell phrase={phrase} minusWords={minusWords} isEditable={isEditable} />
            </div>
        );
    }
}
